import { getService } from '../utils';

export async function requestSoftwareInstall(
  offlineUpdatePath?: string,
  buildId?: string,
  buildName?: string,
): Promise<void> {
  const dataService = getService('softwareUpdate')();

  await dataService.create({
    isSoftwareInstallRequested: true,
    targetBuildID: buildId,
    targetBuildName: buildName,
    offlineUpdatePath,
  });
}
